export const TIME_FORMAT = "YYYY-MM-DD hh:mm:ss";
export const REF_CODE_DURATION = 5;
